<template>
    <div class="bar-calendar-select" :class="containerClass">
        <div class="title_container">
            <div class="title_calendar">{{ label }}</div>
        </div>
        <div class="content" :class="contentClass">
            <!-- left -->
            <!--   :readonly="true"
                    :disabled="true" -->
            <div class="item" @click="openCalendar('min')">
                <im-input
                    ref="input"
                    :theme="theme"
                    :readonly="true"
                    :placeholder="minTitle"
                    :value="formatedMinVal"
                >
                    <template #prepend>
                        <div class="drop_icon">
                            <span class="iconfont icon-data"></span>
                        </div>
                    </template>
                </im-input>
            </div>
            <div class="split"></div>
            <!-- right -->
            <div class="item" @click="openCalendar('max')">
                <im-input
                    ref="input"
                    :readonly="true"
                    :theme="theme"
                    :placeholder="maxTitle"
                    :value="formatedMaxVal"
                >
                    <template #prepend>
                        <div class="drop_icon">
                            <span class="iconfont icon-data"></span>
                        </div>
                    </template>
                </im-input>
            </div>
        </div>
    </div>
</template>

<script>
import mixins from './mixins';
import classNames from 'classnames';
import popMgr from '@/components/global/popMgr';
import CalendarPopup from './m-calendar-popup.vue';
import { dateFormat } from '@/common/format';
export default {
    emits: ['input', 'update:value'],
    name: 'CalendarSelectMobile',
    mixins: [mixins],
    data: function() {
        return {
            type: 'min'
        };
    },
    computed: {
        containerClass() {
            return classNames(this.theme);
        },
        contentClass() {
            return classNames(this.theme);
        },
        minVal() {
            return +this.value.split(',')[0];
        },
        maxVal() {
            return +this.value.split(',')[1];
        },
        formatedMinVal() {
            return this.calcModelVal(this.minVal);
        },
        formatedMaxVal() {
            return this.calcModelVal(this.maxVal);
        }
    },
    methods: {
        calcModelVal(val) {
            if (!val) {
                return ''; 
            }
            const date = new Date(+val);
            return dateFormat('MM/dd/yyyy', date, this.$pinia);
        },
        openCalendar(type) {
            console.log('openCalendar:' + type);
            this.type = type;
            popMgr.create(CalendarPopup, {
                parentIns: this,
                onChange: data => {
                    if (this.type === 'min') {
                        this.output(data, this.maxVal || '');
                    } else {
                        this.output(this.minVal || '', data);
                    }

                    // if (this.maxVal && this.minVal > this.maxVal) {
                    //     this.$emit('input', `${this.maxVal},${this.minVal}`);
                    // } else {
                    //     this.$emit('input', `${this.minVal},${this.maxVal}`);
                    // }
                }
            });
        },
        output(minVal, maxVal) {
            if (maxVal && minVal > maxVal) {
                this.$emit(
                    'update:value',
                    `${this.formatMaxValue(
                        maxVal,
                        'min'
                    )},${this.formatMaxValue(minVal, 'max')}`
                );
            } else {
                this.$emit(
                    'update:value',
                    `${this.formatMaxValue(
                        minVal,
                        'min'
                    )},${this.formatMaxValue(maxVal, 'max')}`
                );
            }
        }
    }
};
</script>

<style lang="scss">
.bar-calendar-select {
    &.standard {
        color: #515666;
        font-size: 14px;
    }
    &.template1 {
        font-size: 14px;
        color: #282828;
    }
    &.template4 {
        font-size: 17px;
        color: #6b7282;
    }
    .title_container {
        margin-bottom: 10px;
    }
    .content {
        height: 40px;
        display: flex;
        align-items: center;
        justify-items: flex-start;
        .item {
            height: 100%;
            flex: 1 0 0;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 0;
            .drop_icon {
                margin-left: 15px;
            }
        }
        &.broker {
            .item {
                .drop_icon {
                    margin-left: 10px;
                }
            }
        }
        .split {
            margin: 0 10px;
            height: 100%;
            width: 10px;
            position: relative;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                width: 100%;
                height: 1px;
            }
        }
        &.standard {
            .split {
                &::before {
                    background: #c6c8d1;
                }
            }
            .iconfont {
                color: #c6c8d1;
            }
        }
        &.template1 {
            .split {
                &::before {
                    background: #dde0ec;
                }
            }
            .iconfont {
                color: #dde0ec;
            }
        }
        &.template4 {
            .split {
                &::before {
                    background: #c6c8d1;
                }
            }
            .iconfont {
                color: #c6c8d1;
            }
        }
    }
}

</style>
